export const version = "bignumber/5.4.1";
//# sourceMappingURL=_version.js.map